// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { ProcessingIssuingComponent } from './processing-issuing.component';
import { BookingIssuingResolver } from './processing-issuing.resolver';
import { ProcessingReassuranceModule } from "../../shared/components/processing-reassurance/processing-reassurance.module";
import { BookingIssuingRouting } from "app_sasha/pages/processing-issuing/processing-issuing.routing";
import { TitleServiceModule } from 'app_sasha/shared/services/title/title-service.module';
import { HasSyscodesGuard } from 'app_sasha/shared/guards/has-syscodes.guard';

@NgModule({
    imports: [
        CommonModule,
        ProcessingReassuranceModule,
        BookingIssuingRouting,
        TitleServiceModule,
    ],
    declarations: [
        ProcessingIssuingComponent,
    ],
    providers: [
        BookingIssuingResolver,
        HasSyscodesGuard,
    ],
})
export class ProcessingIssuingModule { }